import { Divider } from '@mui/material'

import { Form as FormProvider } from 'components/Form'
import Loading from 'components/Loading'
import Paper from 'components/Paper'
import AdminOptionFormHeader from '../components/AdminOptionFormHeader'
import { DOCUMENTATION_URL } from './constants'
import { Form } from './Form'
import { useUpdateWorkspaceProduct } from './hooks/useUpdateWorkspaceProduct'
import { Schema, schema, schemaDefaults } from './schema'
import { FormContainerProps } from './types'

export const FormContainer = ({ workspaceProduct }: FormContainerProps): React.JSX.Element => {
  const { errors, loading, updateWorkspaceProduct } = useUpdateWorkspaceProduct()

  if (!workspaceProduct) {
    return <Loading />
  }

  return (
    <FormProvider<Schema>
      externalErrors={errors}
      id='performance-form'
      loading={loading}
      onSubmit={updateWorkspaceProduct}
      schema={schema}
      schemaDefaults={schemaDefaults(workspaceProduct)}
    >
      {() => (
        <Paper variant='cream'>
          <AdminOptionFormHeader
            documentationUrl={DOCUMENTATION_URL}
            loading={loading}
          />

          <Divider sx={{ marginBottom: 3 }} />

          <Form />
        </Paper>
      )}
    </FormProvider>
  )
}
